var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircledBan = function SvgCircledBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.999a11 11 0 1 0 11 11 11.012 11.012 0 0 0-11-11Zm0 1.833a9.12 9.12 0 0 1 5.797 2.074l-12.89 12.89A9.16 9.16 0 0 1 12 3.832Zm0 18.333a9.12 9.12 0 0 1-5.797-2.073l12.89-12.89A9.16 9.16 0 0 1 12 22.165Z"
  })));
};
export default SvgCircledBan;